import { useState } from "react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import { LinkedInLoginModal } from "common/components/LinkedInLogin";
import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

import LeadsImage from "assets/images/empty-placeholders/inbox.png";

export default function ConnectAccount() {
  const [isOpen, setIsOpen] = useState(false);
  const { rental_subscription } = useSelectedWorkspaceContext();

  const hasPendingRentalAccounts = !!rental_subscription?.rented_count;

  return (
    <>
      <EmptyPlaceholder
        imageSrc={LeadsImage}
        title={
          hasPendingRentalAccounts
            ? "No conversations yet"
            : "Inbox not connected yet"
        }
        subtitle={
          hasPendingRentalAccounts
            ? "Once your Outreach Avatars are ready, you will see their conversations here. You can still connect your own accounts in the meantime"
            : "Connect your LinkedIn account to start messaging your leads"
        }
        actionComponent={
          <RestrictedComponent visibleForPermissions={["accounts_full"]}>
            <Button onClick={() => setIsOpen(true)}>Connect account</Button>
          </RestrictedComponent>
        }
      />

      <LinkedInLoginModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
